import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Book3D } from './ui/Book3D';
import { CtaButton } from './ui/CtaButton';
import { useCountdown } from '../contexts/CountdownContext';
import { useGeoPrice } from '../hooks/useGeoPrice';
import { trackPixelEvent } from '../utils/metaPixel';
import { CHECKOUT_URL, purchaseIncludes } from '../data/content';
export function PurchaseSection() {
  const {
    label
  } = useCountdown();
  const {
    pricing,
    isDetecting
  } = useGeoPrice();
  const handleCheckout = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Europa por Primera Vez',
      currency: pricing.currency
    });
  };
  return <section id="comprar" className="w-full bg-oceano py-14 sm:py-16 lg:py-20" data-id="element-107" data-mp="3jvlekc91lkvo">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-108" data-mp="3ewquz8393sai">
        <h2 className="mx-auto max-w-[34rem] text-center font-display text-[28px] font-bold leading-[1.14] text-polar sm:text-[38px]" data-id="element-109" data-mp="3svgoyeurxbun">
          Accedé hoy a Europa por Primera Vez
        </h2>

        <div className="mx-auto mt-8 max-w-[46rem] overflow-hidden rounded-2xl bg-polar sm:mt-11" data-id="element-110" data-mp="y6wptr8gzqbc">
          <div className="px-5 pt-7 sm:px-8 sm:pt-9" data-id="element-111" data-mp="128hxmy65deeo">
            <p className="text-center font-sans text-[10px] font-medium uppercase tracking-[0.22em] text-caribe" data-id="element-112" data-mp="176ji9nj81ls9">
              Todo lo que incluye tu guía
            </p>

            <div className="mt-6 flex flex-col items-center" data-id="element-113" data-mp="1c6xttfk17dv1">
              <Book3D className="w-[52%] max-w-[190px]" angle={-15} data-id="element-114" data-mp="1h5ipr2s93bdo" />
              
            </div>

            <ol className="mt-8 grid grid-cols-1 gap-x-6 gap-y-2 border-t border-oceano/10 pt-7 sm:grid-cols-2" data-id="element-115" data-mp="1l59fd361jlgm">
              {purchaseIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-116" data-mp="1pz44wn8buunm">
                  <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-caribe" strokeWidth={3} aria-hidden="true" data-id="element-117" data-mp="1uut24jwvjzgr" />
                  <span className="font-sans text-[12.5px] leading-snug text-oceano sm:text-[13px]" data-id="element-118" data-mp="1zt48gknynru8">
                    {item}
                  </span>
                </li>)}
            </ol>

            <p className="mt-6 text-center font-sans text-[11px] font-medium uppercase tracking-[0.14em] text-hierro" data-id="element-119" data-mp="1f6ft1gghftvz">
              +120 páginas de contenido práctico
            </p>
          </div>

          <div className="mt-7 bg-[#F3F0E8] px-5 py-7 text-center sm:px-8 sm:py-9" data-id="element-120" data-mp="1oxaewjptgrgw">
            <span className="inline-block rounded-full bg-travertino px-3.5 py-1.5 font-sans text-[9.5px] font-medium uppercase tracking-[0.16em] text-white" data-id="element-121" data-mp="1k4he26xgy3a3">
              Oferta especial
            </span>

            {isDetecting ? <div className="mt-5" aria-hidden="true" data-id="element-122" data-mp="1sznltbgauvf9">
                <div className="mx-auto h-4 w-20 animate-pulse rounded-full bg-oceano/10" data-id="element-123" data-mp="27tsflqmn81pa" />
                <div className="mx-auto mt-3 h-11 w-52 animate-pulse rounded-lg bg-oceano/10 sm:h-14 sm:w-64" data-id="element-124" data-mp="22vh7plfws19p" />
              </div> : <>
                <p className="mt-5 font-sans text-[13px] text-hierro line-through decoration-hierro/60" data-id="element-125" data-mp="dh2mvc80gyjh">
                  {pricing.priceBefore}
                </p>
                <p className="mt-1 font-display text-[46px] font-bold leading-none text-oceano sm:text-[62px]" data-id="element-126" data-mp="2k4t8xbjsv7vi">
                  {pricing.priceNow}
                </p>
              </>}

            <div className="mt-6 inline-flex items-center gap-3 rounded-lg bg-oceano px-5 py-2.5" data-id="element-127" data-mp="2afrtpnl2wuil">
              <span className="font-sans text-[9px] font-medium uppercase tracking-[0.16em] text-polar/70" data-id="element-128" data-mp="2fdt7pu3ne3n7">
                Tu oferta termina en
              </span>
              <span className="font-sans text-[18px] font-bold leading-none tabular-nums tracking-[0.06em] text-caribe" data-id="element-129" data-mp="21gxzu4z4ui8q">
                {label}
              </span>
            </div>

            <div className="mt-6" data-id="element-130" data-mp="1ri8iqef291tj">
              <CtaButton size="lg" href={CHECKOUT_URL} external onClick={handleCheckout} className="sm:min-w-[340px]" data-id="element-131" data-mp="1wf8kwe8shkfd">
                Quiero acceder ahora
              </CtaButton>
            </div>

            <p className="mt-4 font-sans text-[11px] uppercase tracking-[0.08em] text-hierro" data-id="element-132" data-mp="3qt9iywwim3ee">
              Acceso inmediato · Producto digital · Compra segura
            </p>
          </div>
        </div>
      </div>
    </section>;
}